import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/index.scss';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Portals from  "./Portals";
import { WebSocketProvider } from './WebsocketProvider';

ReactDOM.render(
     <WebSocketProvider>
  <React.StrictMode>
     <Portals />
     <App />
  </React.StrictMode>
     </WebSocketProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
